// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B3dg","content":"styles_content__14XZt","tableWrap":"styles_tableWrap__2-XbW"};